module.exports = __webpack_public_path__ + "img/certificate2-02.048a89b3.png";